import createReactComponent from '../createReactComponent';
export default createReactComponent('flag-check', 'IconFlagCheck', [
  [
    'path',
    {
      d: 'M13.767 15.12a4.983 4.983 0 0 1 -1.767 -1.12a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8.5',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M5 21v-7', key: 'svg-1' }],
  ['path', { d: 'M15 19l2 2l4 -4', key: 'svg-2' }],
]);
